import { Model } from 'modules/core/lib/mobx-rest'

export interface IScore {
  id: string
  employee_id: number
  score: number
  document_id: number
}

class Score extends Model<IScore> {
  static urlRoot() {
    return '/document_split/scores'
  }
}

export default Score
